<template>
  <div
    class="d-flex align-center py-6"
    :class="{
      'flex-column': $vuetify.breakpoint.mdAndDown,
      'flex-row': $vuetify.breakpoint.mdAndDown,
      'white--text': light,
    }"
  >
    <component :is="light ? 'homify-icon-light' : 'homify-icon-dark'" />

    <div
      v-if="$vuetify.breakpoint.mdAndUp && showNav"
      class="d-flex ml-4 flex-row"
      :class="{
        'flex-column': $vuetify.breakpoint.mdAndDown,
        'nav-border--left__dark': !light,
        'nav-border--left': light,
      }"
    >
      <div
        v-for="(navItem, idx) in navItems"
        :key="idx"
        class="px-5 font-weight-light text-h6"
      >
        {{ navItem.name }}
      </div>
    </div>
    <div class="ml-auto" v-if="showAuth">
      <hm-button class="mr-3" text-color="secondary--text" color="transparent"
        >Login</hm-button
      >
      <hm-button>Sign Up</hm-button>
    </div>
  </div>
</template>

<script>
import hmButton from "@/components/hmButton.vue";
import HomifyIconDark from "@/assets/svg/homify-logo__dark.svg";
import HomifyIconLight from "@/assets/svg/homify-logo__light.svg";

export default {
  components: {
    hmButton,
    HomifyIconDark,
    HomifyIconLight,
  },
  props: {
    showAuth: {
      type: Boolean,
      default: false,
    },
    showNav: {
      type: Boolean,
      default: true,
    },
    light: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      navItems: [
        {
          name: "About Us",
          route: "",
        },
        {
          name: "Solutions",
          route: "",
        },
        {
          name: "Services",
          route: "",
        },
        {
          name: "Commitments",
          route: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.nav {
  &-border {
    &--left {
      border-left: 3px solid white;

      &__dark {
        border-left: 3px solid $primaryColor;
      }
    }
  }
}
</style>
